import { combineReducers } from 'redux';
import staffListState from './staffListState';
import jobTypeState from './jobTypeState';
import SendAPIStatusState from './sendAPIStatus';
import staffNextShiftState from './staffNextShiftState';
import signInTimeState from './signInTimeState';
import expectdWorkState from './expectdWorkState';
import expectedWorkBydayState from './expectedWorkBydayState';
import finalWorkState from './finalWorkState';
import finalWorkBydayState from './finalWorkBydayState';
import adjustmentScheduleState from './AdjustmentScheduleState';
import adjustmentScheduleDetailState from './AdjustmentScheduleDetailState';
import allStaffListInAdjustState from './allStaffListInAdjustState';
import staffSalaryListState from './staffSalaryListState';
import supportScheduleShiftState from './supportScheduleShiftState';
import PeopleStatisticsState from './PeopleStatisticsState';
import SignInOutHistoryState from './SignInOutHistoryState';
import PersonsSignInTimeState from './PersonsSignInTimeState';
import dailyCostByHourState from './DailyCostByHourState';
import hourCostChartState from './HourCostChartState';
import min30CostChartState from './Min30CostChartState';
import min30BarCostChartState from './Min30BarCostChartState';
import LeaveRecState from './LeaveRecState';
import AccumulateCostChartState from './AccumulateCostChartState';

import loginState from './loginState';
import loading from './loading';


const itemApp = combineReducers({
  PeopleStatisticsState,
  SignInOutHistoryState,
  PersonsSignInTimeState,
  loginState,
  loading,
  SendAPIStatusState,
  dailyCostByHourState,
  hourCostChartState,
  min30CostChartState,
  min30BarCostChartState,
  LeaveRecState,
  staffListState,
  jobTypeState,
  signInTimeState,
  expectdWorkState,
  finalWorkState,
  finalWorkBydayState,
  adjustmentScheduleDetailState,
  expectedWorkBydayState,
  adjustmentScheduleState,
  allStaffListInAdjustState,
  staffSalaryListState,
  supportScheduleShiftState,
  staffNextShiftState,
  AccumulateCostChartState,
});

export default itemApp;
